import { render, staticRenderFns } from "./SubjecttypeList.vue?vue&type=template&id=f602895a&scoped=true&"
import script from "./SubjecttypeList.vue?vue&type=script&lang=js&"
export * from "./SubjecttypeList.vue?vue&type=script&lang=js&"
import style0 from "./SubjecttypeList.vue?vue&type=style&index=0&id=f602895a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f602895a",
  null
  
)

export default component.exports